import {Component, OnInit} from "@angular/core";
import {AuthService} from "../../services/auth.service";
import {Router} from "@angular/router";
import {Http} from "@angular/http";
import {Title} from "@angular/platform-browser";

declare const __apiVer: any;
declare const __appName: any;

@Component({
  selector: 'app-login',
  templateUrl: './login-page.component.html',
  styles: []
})
export class LoginPageComponent implements OnInit {

  API_VER = __apiVer;
  APP_NAME = __appName;

  params = {
    username: "",
    password: ""
  };

  message: string = "";

  constructor(private authService: AuthService,
              private router: Router,
              private http: Http,
              private title:Title) {
    title.setTitle(`${this.APP_NAME} (API:${this.API_VER})`);
  }

  ngOnInit() {
  }


  onFormSubmit() {
    this.http.post("/login/local", this.params)
      .subscribe((): void => {
        console.log(`login response`);
        this.router.navigate([""]);
      }, e => {
        this.message = "Логин-пароль не очень"
      });
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/login-page/login-page.component.ts